import { createSlice } from "@reduxjs/toolkit";

import Parking from "../../../../../services/Parking2";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, Parking.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateParkingData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.PARKING_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateParkingDataAction = globalStateParkingData.actions;
export const globalStateParkingDataReducer = globalStateParkingData.reducer;
export type globalStateParkingDataState = State;

export default globalStateParkingData;
